import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  UntypedFormArray,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { DataType, OutputParameter } from '@vendasta/automata';
import { validDataTypesForEntities } from '../../../shared/entities';

function validDataTypeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Return a validation error if there's a type that's not valid
    const types = control.value.map((field: { keyName: string; type: DataType }) => field.type);
    if (!validDataTypesForEntities.some((type) => types.includes(type))) {
      return { invalidDataType: true };
    }

    return null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class CustomOutputParamsService {
  returnKeyValuesArray: UntypedFormArray = new UntypedFormArray([], validDataTypeValidator());

  clear(): void {
    this.returnKeyValuesArray.clear();
  }

  removeReturnKeyValue(index: number): void {
    this.returnKeyValuesArray.removeAt(index);
  }

  addReturnKeyValue(keyName?: string, type?: DataType): void {
    const returnKeyValue = new UntypedFormGroup({
      keyName: new FormControl<string>({ value: keyName || '', disabled: false }),
      type: new FormControl<DataType>({ value: type || DataType.DATA_TYPE_UNSPECIFIED, disabled: false }),
    });
    this.returnKeyValuesArray.push(returnKeyValue);
  }

  public buildCustomOutputParametersFromReturnValues(): OutputParameter[] {
    return this.returnKeyValuesArray.controls
      .map((control) => {
        if (!control.get('keyName')?.value) {
          return null;
        }
        return new OutputParameter({
          settings: {
            id: control.get('keyName')?.value,
            name: control.get('keyName')?.value,
            dataType: control.get('type')?.value,
          },
          optional: false,
        });
      })
      .filter((param) => param !== null);
  }
}
